import { useCallback, useState } from 'react';
import MinimalLineChart from 'src/components/minimal-line-chart/MinimalLineChart';

const SmallChartSection = ({ chartName, title, data, color, className = '' }) => {
    const [chartWidth, setChartWidth] = useState(0);

    const container = useCallback((node) => {
        if (node !== null) {
            setChartWidth(node.offsetWidth - 40); // minus the padding
        }
    }, []);

    return (
        <div className={'flex flex-col bg-gray-light p-5 rounded-xl w-full ' + className} ref={container}>
            <span className="font-bold text-md">{chartName}</span>
            <span className="font-bold text-2xl">{title}</span>
            <MinimalLineChart
                width={chartWidth}
                height={
                    chartWidth < 768 && chartWidth > 450
                        ? chartWidth * 0.17
                        : chartWidth < 450
                        ? chartWidth * 0.32
                        : chartWidth * 0.25
                }
                color={color}
                getValue={(val) => val.value}
                data={data}
            />
        </div>
    );
};

export default SmallChartSection;
